// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/restaurant/restaurant_booking.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_entity_place } from "../../entity/place_pb";
import { file_proto_model_booking_restaurant_diner_info } from "./diner_info_pb";
import { file_proto_model_booking_shared_provider_booking_details } from "../shared/provider_booking_details_pb";
import { file_proto_model_financial_budget } from "../../financial/budget_pb";

/**
 * Describes the file proto/model/booking/restaurant/restaurant_booking.proto.
 */
export const file_proto_model_booking_restaurant_restaurant_booking = /*@__PURE__*/
  fileDesc("Cjdwcm90by9tb2RlbC9ib29raW5nL3Jlc3RhdXJhbnQvcmVzdGF1cmFudF9ib29raW5nLnByb3RvEgZjYXJtZW4igAIKEVJlc3RhdXJhbnRCb29raW5nEiEKCnJlc3RhdXJhbnQYASABKAsyDS5jYXJtZW4uUGxhY2USFgoOcmVzZXJ2YXRpb25faWQYAiABKAkSIQoGZGluZXJzGAMgAygLMhEuY2FybWVuLkRpbmVySW5mbxIYChBzcGVjaWFsX3JlcXVlc3RzGAQgAygJEjgKEHByb3ZpZGVyX2RldGFpbHMYBSABKAsyHi5jYXJtZW4uUHJvdmlkZXJCb29raW5nRGV0YWlscxI5ChFidWRnZXRfdmFsaWRhdGlvbhgGIAEoCzIeLmNhcm1lbi5CdWRnZXRWYWxpZGF0aW9uUmVzdWx0QjBaLmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2Jvb2tpbmdiBnByb3RvMw", [file_proto_model_entity_place, file_proto_model_booking_restaurant_diner_info, file_proto_model_booking_shared_provider_booking_details, file_proto_model_financial_budget]);

/**
 * Describes the message carmen.RestaurantBooking.
 * Use `create(RestaurantBookingSchema)` to create a new message.
 */
export const RestaurantBookingSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_restaurant_restaurant_booking, 0);

